// extracted by mini-css-extract-plugin
export default {"modelMail":"styles_modelMail__5N+pp","buttonSection":"styles_buttonSection__KjcS4","button":"styles_button__i5iFH","button1":"styles_button1__D80g5"};